import { put, select } from 'redux-saga/effects';

import { betMessages } from 'constants/toastMessages';

import { addToastAction } from 'core/widgets/Toast/actions';
import { balanceSelector } from 'core/widgets/User';

import { ToastTypes } from 'types/toast';
import { repeatBetSuccessAction } from '../actions';
import { betRepeatRootSelector } from '../selectors';
import { IBetRepeatState } from '../types';
import { sumBets } from 'widgets/Roulette/helpers';
import { refreshBetsSaga } from 'core/widgets/RouletteBet/sagas/refreshBetsSaga';

export function* repeatBetSaga() {
  const balance: number | null = yield select(balanceSelector);
  const { isUsed, isConfirmed, value }: IBetRepeatState = yield select(betRepeatRootSelector);

  const betValue = value;

  if (betValue === null || balance === null || isUsed || isConfirmed) {
    return;
  }

  const lastBetSum = sumBets(betValue);

  if (lastBetSum > balance) {
    yield put(addToastAction({ type: ToastTypes.ERROR, value: betMessages.LOW_BALANCE }));
    return;
  }

  yield put(repeatBetSuccessAction());
  yield refreshBetsSaga({
    past: [],
    present: betValue,
    future: [],
  });
}
